export default "__VITE_ASSET__ElUGWHaf__"